import { GridRowApi } from "@mui/x-data-grid-pro";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface RangerState {
  rangerBulkCalculatedData: any[];
  tabValue: number;
  isRefetch: boolean;
  fulfillmentBulkSwitch: boolean;
}

export const initialState: RangerState = {
  rangerBulkCalculatedData: [],
  tabValue: 1,
  isRefetch: false,
  fulfillmentBulkSwitch: false,
};

export const rangerSlice = createSlice({
  name: "ranger",
  initialState,
  reducers: {
    addRangerBulkCalculatedData: (
      state: RangerState,
      action: PayloadAction<any[]>
    ) => {
      state.rangerBulkCalculatedData = action.payload;
    },
    changeTabValue: (state: RangerState, action: PayloadAction<number>) => {
      state.tabValue = action.payload;
    },

    changedRangerRefetch: (
      state: RangerState,
      action: PayloadAction<boolean>
    ) => {
      state.isRefetch = action.payload;
    },
    removeRangerCalculationData: (state: RangerState) => {
      state.rangerBulkCalculatedData = [];
    },
    changeSwitch: (state: RangerState, action: PayloadAction<boolean>) => {
      state.fulfillmentBulkSwitch = action.payload;
    },
  },
});

export const {
  addRangerBulkCalculatedData,
  changeTabValue,
  removeRangerCalculationData,
  changedRangerRefetch,
  changeSwitch,
} = rangerSlice.actions;
